import React, {ReactNode} from "react";
import {TsrWithBalanceBox} from "./boxes/tsr-with-balance.box";
import { DialogTextBox, DialogHighlightedTextBox } from "../../modal-dialog/boxes/text/dialog-text.box";
import { ModalDialogActionsComponent } from "../../modal-dialog/modal-dialog-actions.component";
import {Check} from "@sparkware/app-utils";
import {CyClass} from "../../../../common/cy-classes";
import {observer} from "mobx-react";

import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";
import {useServices} from "../../../react-hooks/use-services.hook";
import {TimeSpentReminderWithBalanceComponentProps} from "./time-spent-reminder-with-balance.component.props";


export interface ComponentBodyProps extends TimeSpentReminderWithBalanceComponentProps, ComponentServicesPick<'gameRunner'>{

}

const ComponentBody: React.FC<ComponentBodyProps> = observer((props) => {
    const services = useServices();
    const executeContinueButtonAction = async () => {

        props.dialogHandler.close();


        let analyticsAction =  'continue_in_lobby';

        if(props.gameRunner.currentRunningGame) {
            analyticsAction = 'continue_in_game';
            await props.gameRunner.currentRunningGame.gameCommunicationChannel.resumeGamePlay();
        }


        services.analytics.sendAnalytics('reality_check_message', analyticsAction);
    };

    const executeCloseGameButtonAction = async () => {
        services.analytics.sendAnalytics('reality_check_message', 'close_game');

        await props.gameRunner.closeCurrentGame({
            shouldSuggestNextGame: false
        });

        props.dialogHandler.close();
    };

    const getFormattedSessionBalance = (): string => {
        let balanceAbsoluteValue = Math.abs(props.totalNetLoss);
        return services.currency.formatMoney(balanceAbsoluteValue, true);
    };

    const getFormattedPlayingTime = (): string => {
        const playingTimeWithoutUnits = services.sessionTimer.currentSessionTimer.toHoursAndMinutesString();
        //Temporary hack to also display 'h' and 'm', should probably modify TimeSpan class to support this
        return `${playingTimeWithoutUnits.substring(0, 2)}h${playingTimeWithoutUnits.substring(2)}m`;
    };

    const getSessionBalanceText = (): string => {
        const translationKey = props.totalNetLoss < 0 ? "TSR_WINNINGS_TEXT" : "TSR_LOSSES_TEXT";
        return services.translation.translate(translationKey);
    };

    const renderWageredAmount = (): ReactNode => {
        if (Check.isNullOrUndefined(props.amountWagered)) {
            return null;
        }

        return (
            <>
                <DialogTextBox>{services.translation.translate("TSR_WAGERED_AMOUNT")}</DialogTextBox>
                <DialogHighlightedTextBox className={CyClass("cy-tsr-wagered-amount")}>
                    {services.currency.formatMoney(props.amountWagered, true)}
                </DialogHighlightedTextBox>
            </>
        );
    }

    const renderSubtitle = (): ReactNode => {
        if (Check.isNullOrUndefined(props.subtitle)) {
            return null;
        }

        return (
            <DialogHighlightedTextBox>
                {services.translation.translate(props.subtitle)}
            </DialogHighlightedTextBox>
        )
    }

    const renderTotalSessionBalance = (): ReactNode => {
        return (
            <>
                <DialogTextBox>
                    {getSessionBalanceText()}
                </DialogTextBox>
                <DialogHighlightedTextBox className={CyClass("cy-tsr-session-balance-amount")}>
                    {getFormattedSessionBalance()}
                </DialogHighlightedTextBox>
            </>
        );
    }

    const isInGame = Boolean(props.gameRunner.currentRunningGame)
    return (
        <TsrWithBalanceBox>
            {renderSubtitle()}
            <DialogTextBox>{services.translation.translate("TSR_SESSION_TIME_TEXT")}</DialogTextBox>
            <DialogHighlightedTextBox>{getFormattedPlayingTime()}</DialogHighlightedTextBox>
            {renderTotalSessionBalance()}
            {renderWageredAmount()}
            <ModalDialogActionsComponent primaryAction={{
                onClick: executeContinueButtonAction,
                text: services.translation.translate('TSR_CONFIRM')
            }} secondaryAction={isInGame ? {
                onClick: executeCloseGameButtonAction,
                text: services.translation.translate('TSR_CLOSE_GAME')
            } : null} buttonsOnSeparateLines={services.mediaQuery.lAndBelow && !services.mediaQuery.veryLowHeight}/>
        </TsrWithBalanceBox>
    );
})

export const TimeSpentReminderWithBalanceComponent = withServices(ComponentBody, ['gameRunner']);


